import { useEffect } from 'react';
import { onSystemMessage } from '@/services/notifier.service';
import { useSystemWarningActions } from '@/systemWarning/systemWarning.store';

/**
 * Bridges the notifier service (websocket subscription) to the SystemWarning Zustand store.
 * Subscribes to system message events from the backend and updates the store accordingly.
 *
 * This component must be rendered inside SystemWarningStoreProvider.
 */
export const SystemMessageListener = () => {
  const { setSystemMessage } = useSystemWarningActions();

  useEffect(() => {
    // Subscribe to system message websocket events
    const unsubscribe = onSystemMessage((message?: string) => {
      setSystemMessage(message ?? '');
    });

    // Cleanup subscription on unmount
    return unsubscribe;
  }, [setSystemMessage]);

  return null;
};
